<template>
  <Grid>
    <Col12 v-if="editMealPlan">
      <Button
        :label="t('sites.singleSite.financialConfig.mealPlans.form.domains.domainsButton')"
        outlined
        @click="openDialog"
      />
    </Col12>

    <Col12>
      <span class="text-sm font-medium mr-2">{{
        t('sites.singleSite.financialConfig.mealPlans.form.domains.mealplanAccess')
      }}</span>
      <span>{{
        t('sites.singleSite.financialConfig.mealPlans.form.domains.mealPlanAccessValue', {
          number: numberDomains,
        })
      }}</span>
    </Col12>
  </Grid>

  <DomainsDialog
    v-if="dialogVisible"
    v-model:visible="dialogVisible"
    :domains="value"
    @add-domains="updateValue"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useField } from 'vee-validate';
import { computed, inject, ref } from 'vue';
import DomainsDialog from './domains-dialog/DomainsDialog.vue';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../routes';

// Set localization
const { t } = useI18n();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');

// Set valid domains field
const { value } = useField<string[]>(`${formNamespace}valid_email_domains`);

// Ref for dialog visibility
const dialogVisible = ref<boolean>(false);

// Computed property for valid domains
const numberDomains = computed<number>(() => value.value?.length);

// Method to open dialog
const openDialog = (): void => {
  dialogVisible.value = true;
};

// Update value on dialog close
const updateValue = (domains: string[]): void => {
  value.value = domains;
};
</script>
